import React, { MouseEventHandler } from "react";
import styled from "styled-components";

import { Tag } from "../../database.types";

type SingleTagProps = {
  onClick: MouseEventHandler<HTMLButtonElement>;
  isActive: boolean;
  disabled?: boolean;
  withCount?: boolean;
} & Tag;

const SingleTag = ({
  id,
  name,
  created_at,
  onClick,
  isActive,
  disabled,
  links_count,
  withCount = false,
}: SingleTagProps) => {
  const isLinksCount = !links_count || links_count <= 0;
  
  return (
    <StyledSingleTag
      active={isActive ? "true" : "false"}
      onClick={onClick}
      disabled={disabled || isLinksCount}
    >
      {name}
      {withCount && links_count ? ` (${links_count})` : null}
    </StyledSingleTag>
  );
};

const StyledSingleTag = styled.button<{ active: string }>`
  background-color: ${({ theme }) => theme.colors.tagBg};
  color: ${({ theme }) => theme.colors.tagText};
  width: fit-content;
  padding: 2px 5px;
  border-radius: ${({ theme }) => theme.radii.small};
  cursor: pointer;
  border: none;
  font-size: ${({ theme }) => theme.fontSize.Button};
  border: 1px solid
    ${({ theme, active }) =>
      active === "true" ? theme.colors.tagText : "transparent"};
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export default SingleTag;
